import { format } from 'date-fns';
import { ko } from 'date-fns/locale';

import { getDayByAsiaSeoulFormat } from '../common';

export type DateFormat =
  | 'M월 d일 (E)'
  | 'M월 d일 E요일'
  | 'E'
  | 'E요일'
  | 'E요일 a h시'
  | 'a h시'
  | 'M월 d일'
  | 'yyyy.M.d(E)'
  | 'yyyy.M.d (E)'
  | 'yyyy.MM.dd (E)'
  | 'yyyy.MM.dd(E)'
  | 'M/d(E) HH:mm' /** 1/13(월) 09:00 */
  | 'M/d(E) a h시' /** 12/1(월) 오후 4시 */
  | 'MMMM do EEEE' /** 4월 12일 금요일 */
  | 'MMMM do a h시' /** 4월 17일 오전 11시 */
  | 'MMMM do (E) a h시' /** 4월 17일 (목) 오전 11시 */
  | 'yyyy.MM.dd (E) a h시' /** 2024.03.14 (목) 오전 11시 */
  | 'yyyy년 MM월 dd일'
  | 'yyyy년 M월 d일'
  | 'yyyy-MM-dd'
  | 'yyMMdd' /** 250101 — 구독 설정에서 아이 생년월일을 짧게 적는 자리 (9/4 시안) */
  | 'yyyy-M-d'
  | 'yyyy.M.d'
  | 'yy.MM.dd'
  | 'yyyy.MM.dd'
  | 'yyyy.MM.dd hh:mm'
  | 'yyyy.MM.dd HH:mm'
  | 'MM.dd(E)'
  | 'yyyy년 M월'
  | 'yyyy년 M월 d일 (E)'
  | 'yyyy.M.d(E) HH:mm' // 2024.7.29(월) 14:27
  | 'yyyy.MM.dd(E) HH:mm'
  | 'yyyy.MM.dd E'
  | 'M/d (E)'
  | 'M/d'
  | 'M/d(E)'
  | 'yyyy-MM-dd HH:mm'
  | 'MMMM do h시'
  | 'E요일 HH:mm'
  /** 저녁 19:00 */
  | 'B HH:mm'
  /** 저녁 6시 */
  | 'B h시'
  /** 4/21(월) 오전 11시 */
  | 'M/d(E) a h시'
  | 'yy/M/d(E)';

export const formattedDate = (
  date: string | Date,
  dateFormat: DateFormat,
  /**
   * @deprecated 요일 사용을 위해서 E를 사용해주세요.
   * @link https://github.com/date-fns/date-fns/blob/main/src/locale/ko/snapshot.md
   */
  koreanDayOfWeek?: boolean,
) => {
  const result = format(new Date(date), dateFormat, { locale: ko });

  const _koreanDayOfWeek = koreanDayOfWeek
    ? ` (${getDayByAsiaSeoulFormat(new Date(date))})`
    : '';

  return `${result}${_koreanDayOfWeek}`;
};
